// Configuración de la API
import { ENVIRONMENT } from './environment';

// URL base de la API
const API_URL = ENVIRONMENT.API_URL;

// URL para el backend DemoCrudInt
export const DEMO_CRUD_INT_API_URL = ENVIRONMENT.API_URL;
export const DEMO_CRUD_CHAR_API_URL = ENVIRONMENT.API_URL;
export const DEMO_CRUD_CHAR2_API_URL = ENVIRONMENT.API_URL;

export { API_URL };

// Función para obtener la URL completa de un endpoint
export const getApiUrl = (endpoint) => {
  const base = String(API_URL || '').replace(/\/+$/, '');
  const path = String(endpoint || '').replace(/^\/+/, '');
  return `${base}/${path}`;
};

/**
 * Extrae el MgkMessage del header de respuesta axios.
 * El backend siempre pone el resultado en el header "MgkMessage" como JSON.
 * Body = objeto guardado (dato), Header = resultado de la operación (número, mensaje, tipo).
 *
 * Uso en servicios:
 *   const response = await axios.post(...)
 *   return parseMgkResponse(response)
 *   // → { Number, Message, Type, Code, ... } o fallback si no hay header
 */
export const parseMgkResponse = (response) => {
  const raw = response.headers['mgkmessage'];
  if (raw) {
    try { return JSON.parse(raw); } catch (_) { /* header malformado */ }
  }
  // Fallback: si el body ya es un MgkMessage (Number existe), devolverlo directo
  const d = response.data;
  if (d && typeof d.Number === 'number') return d;
  // Sin mensaje — éxito genérico
  return { Number: 0, Message: 'OK', Type: 'success' };
};

// Función para obtener la URL completa de un endpoint para DemoCrudInt
export const getDemoCrudIntApiUrl = (endpoint) => {
  return `${DEMO_CRUD_INT_API_URL}${endpoint}`;
};

// Función para obtener la URL completa de un endpoint para DemoCrudChar
export const getDemoCrudCharApiUrl = (endpoint) => {
  return `${DEMO_CRUD_CHAR_API_URL}${endpoint}`;
};

// Función para obtener la URL completa de un endpoint para DemoCrudChar2
export const getDemoCrudChar2ApiUrl = (endpoint) => {
  return `${DEMO_CRUD_CHAR2_API_URL}${endpoint}`;
};

// Función para obtener la URL completa de un endpoint para la API CrudApi
/* export const getCrudApiUrl = (endpoint) => {
  return `${BASE_API_URL}${endpoint}`;
}; */
